// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/insegne?societaId=1',
    requestBody: null,
    response: '{"success":true,"data":[{"id":11,"codice":"BRICOCENTER","nome":"BRICOCENTER"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/mappatura/configurazione?societaId=1',
    requestBody: null,
    response: '{"success":true,"data":{"baseUrl":"http://…/rest/api","username":"UTENTE@GO","secretManagerRef":"go-password","causaleDocumento":"C1S","attivo":true,"note":null}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/mappatura?societaId=1&insegnaId=11',
    requestBody: null,
    response: '{"success":true,"data":[{"id":21,"codice":"NOM00018","ragioneSociale":"Bricocenter Italia spa","partitaIva":"…","mappatura":null,"filiali":[{"id":3,"nome":"CINISELLO","citta":"…","cap":"…","mappatura":null}]}],"daMappare":68}'
  },
  {
    method: 'PUT',
    endpoint: '/api/bop-go/mappatura/configurazione',
    requestBody: '{"societaId":1,"baseUrl":"…","username":"…","secretManagerRef":"…","causaleDocumento":"C1S","attivo":true}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/mappatura/drive/verifica',
    requestBody: '{"societaId":1,"driveFolderId":"…"}',
    response: '{"success":true,"data":{"folderId":"…","nome":"da_elaborare","cartellaPadre":"Import_ordini_bop_go","driveCondiviso":true,"puoScrivere":true,"fileInAttesa":3,"file":[{"id":"…","nome":"ordini.xml","dimensione":12345,"modificato":"…"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini/drive/scansiona',
    requestBody: '{"societaId":1}',
    response: '{"success":true,"data":{"fileTrovati":3,"lotti":[{"insegna":"Bricocenter","caricamentoId":12,"file":["ordini.xml (tracciato bricocenter-xml)"],"esito":"inviati a GO 20 ordini su 20","ordini":20,"inviati":20}],"fileNonRiconosciuti":[],"fileDuplicati":[],"fileIgnorati":[],"errori":[],"notificaInviata":true,"durataMs":45000}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/mappatura/verifica-connessione',
    requestBody: '{"societaId":1}',
    response: '{"success":true,"data":{"ok":true,"baseUrl":"…","username":"UTENTE@GO","durataMs":195}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/mappatura/proponi',
    requestBody: '{"societaId":1,"insegnaId":11}',
    response: '{"success":true,"data":{"proposteClienti":[],"proposteFiliali":[],"totaliGo":{"clienti":1879,"filiali":604},"durataMs":3200}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/mappatura/conferma',
    requestBody: '{"societaId":1,"voci":[{"tipo":"FILIALE","entitaId":3,"codiceGo":"00000008","descrizioneGo":"BRICOCENTER CINISELLO BALSAMO 32","confidenza":"numero punto vendita 32"}]}',
    response: '{"success":true,"data":{"salvate":1}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/bop-go/mappatura/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
